import { Component, computed, input, output } from '@angular/core';
import { IconComponent } from '@cumlaude/shared-components-icons';
import { TooltipDirective } from '@cumlaude/shared-components-overlays';

export type CheckboxState = boolean | 'indeterminate';

export enum CheckboxLabelPosition {
	LEFT = 'left',
	RIGHT = 'right',
}

@Component({
	selector: 'app-checkbox',
	templateUrl: './checkbox.component.html',
	styleUrls: ['./checkbox.component.scss'],
	imports: [TooltipDirective, IconComponent],
})
export class CheckboxComponent {
	readonly value = input<CheckboxState>(false);
	readonly label = input('');
	readonly enabled = input<boolean | undefined>(true);
	readonly tooltip = input('');
	readonly labelPosition = input<CheckboxLabelPosition>(CheckboxLabelPosition.RIGHT);

	readonly valueAsBoolean = computed(() => {
		const value = this.value();
		return value === 'indeterminate' ? false : value;
	});

	readonly checkboxIcon = computed<'checkbox-checked' | 'checkbox-indeterminate' | null>(() => {
		const value = this.value();
		if (value === 'indeterminate') {
			return 'checkbox-indeterminate';
		}

		return value ? 'checkbox-checked' : null;
	});

	readonly checkboxIconColor = computed(() => ((this.enabled() ?? true) ? 'primary-1' : 'typography-5'));

	/**
	 * Geen model omdat de output nooit indeterminate kan zijn.
	 */
	valueChange = output<boolean>();

	protected readonly CheckboxLabelPosition = CheckboxLabelPosition;
}
